/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// @ts-ignore
import * as runtime from '../runtime';
// @ts-ignore
import type {
// @ts-ignore
  AddOrRemoveSkusToProductList,
// @ts-ignore
  AssignOrUnassignRetailersToProductList,
// @ts-ignore
  AssignOrUnassignStoresToProductList,
// @ts-ignore
  EffectivePortfolio,
// @ts-ignore
  ProductList,
// @ts-ignore
  ProductListCreateRequest,
// @ts-ignore
  ProductListListResponse,
// @ts-ignore
  ProductListRetailerAssignmentListResponse,
// @ts-ignore
  ProductListSkuIdListResponse,
// @ts-ignore
  ProductListStoreAssignmentListResponse,
// @ts-ignore
  ProductListUpdateRequest,
} from '../models/index';
// @ts-ignore
import {
// @ts-ignore
    AddOrRemoveSkusToProductListFromJSON,
// @ts-ignore
    AddOrRemoveSkusToProductListToJSON,
// @ts-ignore
    AssignOrUnassignRetailersToProductListFromJSON,
// @ts-ignore
    AssignOrUnassignRetailersToProductListToJSON,
// @ts-ignore
    AssignOrUnassignStoresToProductListFromJSON,
// @ts-ignore
    AssignOrUnassignStoresToProductListToJSON,
// @ts-ignore
    EffectivePortfolioFromJSON,
// @ts-ignore
    EffectivePortfolioToJSON,
// @ts-ignore
    ProductListFromJSON,
// @ts-ignore
    ProductListToJSON,
// @ts-ignore
    ProductListCreateRequestFromJSON,
// @ts-ignore
    ProductListCreateRequestToJSON,
// @ts-ignore
    ProductListListResponseFromJSON,
// @ts-ignore
    ProductListListResponseToJSON,
// @ts-ignore
    ProductListRetailerAssignmentListResponseFromJSON,
// @ts-ignore
    ProductListRetailerAssignmentListResponseToJSON,
// @ts-ignore
    ProductListSkuIdListResponseFromJSON,
// @ts-ignore
    ProductListSkuIdListResponseToJSON,
// @ts-ignore
    ProductListStoreAssignmentListResponseFromJSON,
// @ts-ignore
    ProductListStoreAssignmentListResponseToJSON,
// @ts-ignore
    ProductListUpdateRequestFromJSON,
// @ts-ignore
    ProductListUpdateRequestToJSON,
} from '../models/index';

export interface CreateProductListRequest {
    productListCreateRequest: ProductListCreateRequest;
}

export interface DeleteProductListRequest {
    id: string;
}

export interface GetEffectivePortfolioRequest {
    storeId: string;
    supplierId?: string;
}

export interface GetProductListRequest {
    id: string;
}

export interface GetProductListRetailerAssignmentsRequest {
    id: string;
    status?: string;
    offset?: number;
    limit?: number;
}

export interface GetProductListSkuIdsRequest {
    id: string;
    offset?: number;
    limit?: number;
}

export interface GetProductListStoreAssignmentsRequest {
    id: string;
    status?: string;
    offset?: number;
    limit?: number;
}

export interface ListProductListsRequest {
    query?: string;
    status?: string;
    offset?: number;
    limit?: number;
    supplierId?: string;
}

export interface UpdateProductListRequest {
    id: string;
    productListUpdateRequest: ProductListUpdateRequest;
}

export interface UpdateProductListRetailerAssignmentsRequest {
    id: string;
    assignOrUnassignRetailersToProductList: AssignOrUnassignRetailersToProductList;
}

export interface UpdateProductListSkuMembershipRequest {
    id: string;
    addOrRemoveSkusToProductList: AddOrRemoveSkusToProductList;
}

export interface UpdateProductListStoreAssignmentsRequest {
    id: string;
    assignOrUnassignStoresToProductList: AssignOrUnassignStoresToProductList;
}

/**
 * 
 */
export class ProductListsApi extends runtime.BaseAPI {

    /**
     * Create a new product list
     */
    async createProductListRaw(requestParameters: CreateProductListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductList>> {
        if (requestParameters.productListCreateRequest === null || requestParameters.productListCreateRequest === undefined) {
            throw new runtime.RequiredError('productListCreateRequest','Required parameter requestParameters.productListCreateRequest was null or undefined when calling createProductList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/products/lists`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductListCreateRequestToJSON(requestParameters.productListCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductListFromJSON(jsonValue));
    }

    /**
     * Create a new product list
     */
    async createProductList(requestParameters: CreateProductListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductList> {
        const response = await this.createProductListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a product list by ID
     */
    async deleteProductListRaw(requestParameters: DeleteProductListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteProductList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/lists/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a product list by ID
     */
    async deleteProductList(requestParameters: DeleteProductListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteProductListRaw(requestParameters, initOverrides);
    }

    /**
     * Preview the effective Product List portfolio for a store and supplier
     */
    async getEffectivePortfolioRaw(requestParameters: GetEffectivePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EffectivePortfolio>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling getEffectivePortfolio.');
        }

        const queryParameters: any = {};

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/portfolio`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EffectivePortfolioFromJSON(jsonValue));
    }

    /**
     * Preview the effective Product List portfolio for a store and supplier
     */
    async getEffectivePortfolio(requestParameters: GetEffectivePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EffectivePortfolio> {
        const response = await this.getEffectivePortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get details of a specific product list
     */
    async getProductListRaw(requestParameters: GetProductListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductList>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProductList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/lists/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductListFromJSON(jsonValue));
    }

    /**
     * Get details of a specific product list
     */
    async getProductList(requestParameters: GetProductListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductList> {
        const response = await this.getProductListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get retailer assignments for a product list
     */
    async getProductListRetailerAssignmentsRaw(requestParameters: GetProductListRetailerAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductListRetailerAssignmentListResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProductListRetailerAssignments.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/lists/{id}/retailers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductListRetailerAssignmentListResponseFromJSON(jsonValue));
    }

    /**
     * Get retailer assignments for a product list
     */
    async getProductListRetailerAssignments(requestParameters: GetProductListRetailerAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductListRetailerAssignmentListResponse> {
        const response = await this.getProductListRetailerAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SKU IDs assigned to a product list
     */
    async getProductListSkuIdsRaw(requestParameters: GetProductListSkuIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductListSkuIdListResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProductListSkuIds.');
        }

        const queryParameters: any = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/lists/{id}/products`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductListSkuIdListResponseFromJSON(jsonValue));
    }

    /**
     * Get SKU IDs assigned to a product list
     */
    async getProductListSkuIds(requestParameters: GetProductListSkuIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductListSkuIdListResponse> {
        const response = await this.getProductListSkuIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get store assignments for a product list
     */
    async getProductListStoreAssignmentsRaw(requestParameters: GetProductListStoreAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductListStoreAssignmentListResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProductListStoreAssignments.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/lists/{id}/stores`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductListStoreAssignmentListResponseFromJSON(jsonValue));
    }

    /**
     * Get store assignments for a product list
     */
    async getProductListStoreAssignments(requestParameters: GetProductListStoreAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductListStoreAssignmentListResponse> {
        const response = await this.getProductListStoreAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of product lists
     */
    async listProductListsRaw(requestParameters: ListProductListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductListListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/lists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductListListResponseFromJSON(jsonValue));
    }

    /**
     * Get a list of product lists
     */
    async listProductLists(requestParameters: ListProductListsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductListListResponse> {
        const response = await this.listProductListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a product list by ID
     */
    async updateProductListRaw(requestParameters: UpdateProductListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProductList.');
        }

        if (requestParameters.productListUpdateRequest === null || requestParameters.productListUpdateRequest === undefined) {
            throw new runtime.RequiredError('productListUpdateRequest','Required parameter requestParameters.productListUpdateRequest was null or undefined when calling updateProductList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/products/lists/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProductListUpdateRequestToJSON(requestParameters.productListUpdateRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a product list by ID
     */
    async updateProductList(requestParameters: UpdateProductListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProductListRaw(requestParameters, initOverrides);
    }

    /**
     * Assign or unassign retailers from a product list
     */
    async updateProductListRetailerAssignmentsRaw(requestParameters: UpdateProductListRetailerAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProductListRetailerAssignments.');
        }

        if (requestParameters.assignOrUnassignRetailersToProductList === null || requestParameters.assignOrUnassignRetailersToProductList === undefined) {
            throw new runtime.RequiredError('assignOrUnassignRetailersToProductList','Required parameter requestParameters.assignOrUnassignRetailersToProductList was null or undefined when calling updateProductListRetailerAssignments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/products/lists/{id}/retailers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignOrUnassignRetailersToProductListToJSON(requestParameters.assignOrUnassignRetailersToProductList),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assign or unassign retailers from a product list
     */
    async updateProductListRetailerAssignments(requestParameters: UpdateProductListRetailerAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProductListRetailerAssignmentsRaw(requestParameters, initOverrides);
    }

    /**
     * Add or remove products (SKUs) to/from a product list
     */
    async updateProductListSkuMembershipRaw(requestParameters: UpdateProductListSkuMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProductListSkuMembership.');
        }

        if (requestParameters.addOrRemoveSkusToProductList === null || requestParameters.addOrRemoveSkusToProductList === undefined) {
            throw new runtime.RequiredError('addOrRemoveSkusToProductList','Required parameter requestParameters.addOrRemoveSkusToProductList was null or undefined when calling updateProductListSkuMembership.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/products/lists/{id}/products`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrRemoveSkusToProductListToJSON(requestParameters.addOrRemoveSkusToProductList),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add or remove products (SKUs) to/from a product list
     */
    async updateProductListSkuMembership(requestParameters: UpdateProductListSkuMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProductListSkuMembershipRaw(requestParameters, initOverrides);
    }

    /**
     * Assign or unassign stores from a product list
     */
    async updateProductListStoreAssignmentsRaw(requestParameters: UpdateProductListStoreAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProductListStoreAssignments.');
        }

        if (requestParameters.assignOrUnassignStoresToProductList === null || requestParameters.assignOrUnassignStoresToProductList === undefined) {
            throw new runtime.RequiredError('assignOrUnassignStoresToProductList','Required parameter requestParameters.assignOrUnassignStoresToProductList was null or undefined when calling updateProductListStoreAssignments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/products/lists/{id}/stores`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignOrUnassignStoresToProductListToJSON(requestParameters.assignOrUnassignStoresToProductList),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assign or unassign stores from a product list
     */
    async updateProductListStoreAssignments(requestParameters: UpdateProductListStoreAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProductListStoreAssignmentsRaw(requestParameters, initOverrides);
    }

}
